import { useStyletron } from 'parkdepot-shared/theme'
import Button from 'parkdepot-shared/components/Buttons/Button'
import { BUTTON_KIND, BUTTON_SIZE } from 'parkdepot-shared/components/Buttons/types'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
    loading: boolean
    onConfirm: () => void
}

const DeleteVehicle: FC<Props> = ({ loading, onConfirm }) => {
    const { t } = useTranslation()
    const [css, theme] = useStyletron()
    return (
        <>
            <div>
                <i
                    className={`wemolo-car-delete ${css({
                        color: theme.colors.primary,
                        fontSize: '2.4rem',
                        transform: 'scaleX(-1)'
                    })}`}
                />
            </div>
            <div
                className={css({
                    ...theme.typography.HeadingSmall,
                    margin: '2rem 0'
                })}
            >
                {t('profile.vehicle.deleteModal.title')}
            </div>
            <div
                className={css({
                    ...theme.typography.ParagraphMedium,
                    color: theme.colors.black,
                    marginBottom: '2rem'
                })}
            >
                {t('profile.vehicle.deleteModal.content')}
            </div>
            <Button
                id="delete-vehicle-btn"
                $size={BUTTON_SIZE.medium}
                $kind={BUTTON_KIND.primary}
                isLoading={loading}
                disabled={loading}
                overrides={{
                    BaseButton: {
                        style: {
                            width: '100%',
                            ':focus': {
                                border: 'transparent'
                            }
                        }
                    }
                }}
                onClick={onConfirm}
            >
                <div>{t('profile.vehicle.deleteModal.confirm')}</div>
            </Button>
        </>
    )
}
export default DeleteVehicle
